import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PublicComponent } from '../public/index.component';

@Component({
  selector: 'authorizePP',
  template: `
    <div (click)="ReturnLogin()" [ngStyle]="{ 'background-color': backgroundColor }">
      <span>
        Your token is expire! Please login again ({{Time}}).
      </span>
    </div>
  `,
  styles:[`
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: white;
    text-transform: uppercase;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica, sans-serif;
    font-size: 25px;
    position: fixed;
    z-index: 5;
    top: 0px;
    width: 100%;
    z-index: 999999;
    cursor: pointer;
  }
  span:hover {
    opacity: 0.7
  }

  span {
    user-select: none;
    background-color: #ff5858;
    padding: 16px;
    text-align: center;
  }
  `]
})
export class AuthorizePPComponent {
  pb_func: PublicComponent = new PublicComponent();
  @Input() backgroundColor:string; 
  myVar:any = null;
  Time = 5;
  constructor(private router: Router) { 
    this.myVar = setInterval(()=> {
      this.Time = this.Time - 1;
      if(this.Time <= 0) {
        clearInterval(this.myVar);
        this.ReturnLogin();
      }
    }, 1000);
  }

  ngOnInit() {

  }

  ReturnLogin() {
    clearInterval(this.myVar);
    var this_sav = this;
    window.localStorage.removeItem(this_sav.pb_func.token);
    this_sav.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/authorizePP/authorizePP.component.ts